/*
This hook manages multiple filtering and the expected filter state is:
{
  filterNameA: [idA, idB, idC],
  filterNameB: [idX, idY, idZ],
  filterNameC: [idA, idB, idC],
};
*/

import { useState } from 'react';
import isEmpty from 'lodash/isEmpty';

export const useMultipleFilters = (initialSate = {}) => {
  const [filters, setFilters] = useState(initialSate);

  const checkIsIdAddedToFilter = (filterName, id) => (
    filters[filterName].includes(id)
  );

  const addIdToFilter = (filterName, id) => {
    if (checkIsIdAddedToFilter(filterName, id)) {
      return;
    }

    setFilters({
      ...filters,
      [filterName]: [...filters[filterName], id],
    });
  };

  const removeIdFromFilter = (filterName, id) => (
    setFilters({
      ...filters,
      [filterName]: filters[filterName].filter(filteredId => filteredId !== id),
    })
  );

  const toggleIdInFilter = (filterName, id) => (
    filters[filterName].includes(id) ? removeIdFromFilter(filterName, id) : addIdToFilter(filterName, id)
  );

  const clearIdsInFilter = () => (
    setFilters(Object.fromEntries(Object.keys(filters).map(key => [key, []])))
  );

  const checkHasIdsInFilter = (filterName) => (
    !isEmpty(filters[filterName])
  );

  const hasIdsInAnyFilters = Object.values(filters).some((filter) => !!filter.length);

  return {
    filters,
    setFilters,
    addIdToFilter,
    removeIdFromFilter,
    toggleIdInFilter,
    clearIdsInFilter,
    checkIsIdAddedToFilter,
    checkHasIdsInFilter,
    hasIdsInAnyFilters,
  };
};
